// Third Party Imports
import PropTypes from 'prop-types';
import React from 'react';

// Artifactory Imports
import {ButtonIcon} from '@homeaway/react-buttons';
import {CHEVRON_LEFT__24, CHEVRON_RIGHT__24} from '@homeaway/svg-defs';

// Style
import './CarouselButtonsMobile.less';

function CarouselButtonsMobile({handlePrev, handleNext}) {
    return (
        <React.Fragment>
            <div
                className="carousel__nav-wrapper carousel__nav-wrapper--prev carousel__nav-wrapper--reduced"
                key="carousel__nav-wrapper-0"
            >
                <ButtonIcon
                    className="carousel__nav carousel__nav--prev carousel__nav--reduced"
                    onClick={handlePrev}
                    circle
                    label="Previous"
                    svgMarkup={CHEVRON_LEFT__24}
                />
            </div>
            <div
                className="carousel__nav-wrapper carousel__nav-wrapper--next carousel__nav-wrapper--reduced"
                key="carousel__nav-wrapper-1"
            >
                <ButtonIcon
                    className="carousel__nav carousel__nav--next carousel__nav--reduced"
                    onClick={handleNext}
                    circle
                    label="Next"
                    svgMarkup={CHEVRON_RIGHT__24}
                />
            </div>
        </React.Fragment>
    );
}

CarouselButtonsMobile.propTypes = {
    handlePrev: PropTypes.func.isRequired,
    handleNext: PropTypes.func.isRequired
};

export default CarouselButtonsMobile;


// WEBPACK FOOTER //
// ./src/universal/components/image-carousel/carouselTemplates/CarouselButtonsMobile/CarouselButtonsMobile.js